/* This file was generated by running "node scripts/generateTranslations.js". */
/* Created: 2025-02-26 17:03:55 */

const Keys = {
  ManageMyBooking: 'ManageMyBooking',
  backToDashboard: 'backToDashboard'
}; export default Keys;